import { useRef, useState } from "react";

interface DropZoneProps {
  label: string;
  accept: string;
  file: File | null;
  onPick: (file: File | null) => void;
  hint?: string;
}

export function DropZone({ label, accept, file, onPick, hint }: DropZoneProps) {
  const [over, setOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <label
      className={`panel block cursor-pointer px-4 py-5 transition ${
        over ? "border-accent-500 bg-ink-800" : "hover:border-ink-500"
      }`}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        const f = e.dataTransfer.files?.[0];
        if (f) onPick(f);
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => onPick(e.target.files?.[0] ?? null)}
      />
      <div className="flex items-baseline justify-between">
        <span className="text-xs uppercase tracking-wide text-zinc-500">
          {label}
        </span>
        {file ? (
          <button
            type="button"
            className="text-xs text-zinc-500 hover:text-zinc-300"
            onClick={(e) => {
              e.preventDefault();
              onPick(null);
              if (inputRef.current) inputRef.current.value = "";
            }}
          >
            clear
          </button>
        ) : null}
      </div>
      {file ? (
        <div className="mt-2">
          <div className="truncate font-mono text-sm text-zinc-200">
            {file.name}
          </div>
          <div className="text-xs text-zinc-500">
            {(file.size / 1024 / 1024).toFixed(2)} MB
          </div>
        </div>
      ) : (
        <div className="mt-2">
          <div className="text-sm text-zinc-300">
            Drop file or <span className="text-accent-400">pick…</span>
          </div>
          {hint ? (
            <div className="mt-1 text-xs text-zinc-500">{hint}</div>
          ) : null}
        </div>
      )}
    </label>
  );
}
